import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useSiteI18n } from '../SiteI18n';
import { SiteSEO } from '../SiteSEO';
import { SiteCtaBlock } from '../components/SitePageParts';
import { PillarShowcase } from '../components/PillarShowcase';
import { PILLARS } from '../data/pillarsContent';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

const SiteSolutii: React.FC = () => {
  const { t, lang } = useSiteI18n();
  return (
    <>
      <SiteSEO
        path="/site/solutii"
        title={lang === 'ro'
          ? 'Soluții AETHERIS — 7 piloni pentru orașe, sănătate, clădiri și industrie'
          : 'AETHERIS Solutions — 7 pillars for cities, health, buildings and industry'}
        description={lang === 'ro'
          ? 'AETHERIS City OS, Building & KNX, Care, Mind, Secure, Intelligence și Finance — un singur ecosistem AI-native, conform GDPR, NIS2 și DSA.'
          : 'AETHERIS City OS, Building & KNX, Care, Mind, Secure, Intelligence and Finance — one AI-native ecosystem, GDPR/NIS2/DSA compliant.'}
      />

      {/* HERO */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1200px] h-[600px] bg-gradient-to-br from-primary/30 via-cyan-500/10 to-violet-500/20 rounded-full blur-[140px] site-aurora" />
          <div className="absolute inset-0 site-grid-bg" />
        </div>

        <div className="container mx-auto px-4 lg:px-6">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto text-center"
          >
            <Badge className="mb-5 bg-primary/10 text-primary border border-primary/30 backdrop-blur-md">
              <Sparkles className="h-3 w-3 mr-1.5" /> {t.pillars.label}
            </Badge>
            <h1 className="text-4xl md:text-7xl font-black tracking-tight leading-[0.98] mb-5">
              <span className="bg-gradient-to-br from-foreground via-foreground to-foreground/40 bg-clip-text text-transparent block">
                {lang === 'ro' ? 'Șapte soluții.' : 'Seven solutions.'}
              </span>
              <span className="bg-gradient-to-br from-primary via-primary to-cyan-400 bg-clip-text text-transparent block mt-1">
                {lang === 'ro' ? 'Un singur ecosistem.' : 'One ecosystem.'}
              </span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              {t.pillars.subtitle}
            </p>
            <div className="mt-7 flex flex-wrap justify-center gap-2">
              {PILLARS.map((p) => (
                <a
                  key={p.slug}
                  href={`#${p.slug}`}
                  className={`text-sm px-3 py-1.5 rounded-full border bg-card/40 backdrop-blur-md hover:scale-105 transition-transform ${p.accentClass}`}
                >
                  {p[lang].tag}
                </a>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      <PillarShowcase />
      <SiteCtaBlock />
    </>
  );
};
export default SiteSolutii;
